<template>
  <article>
    <section class="xbed-sub-title">
      <span>智能硬件管理</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>智能门锁管理</BreadcrumbItem>
        <BreadcrumbItem>门锁详情</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <section>
      <Tabs @on-click="changeTab" style="padding-left:20px">
        <TabPane label="基本信息" name="basicInfo">
          <Form label-position="left">
            <FormItem class="row" label="门锁型号" :label-width="200">
              <span>{{lockModelName}}</span>
            </FormItem>
            <FormItem class="row" label="密码功能的类型" :label-width="200">
              <span>{{['订单密码','无密码','即时密码'][basicInfo.pwdFunc]}}</span>
            </FormItem>
            <FormItem class="row" label="门锁id" :label-width="200">
              <span>{{lockId}}</span>
            </FormItem>
            <FormItem class="row" label="门锁编码" :label-width="200">
              <span>{{basicInfo.lockSn}}</span>
            </FormItem>
            <FormItem class="row" label="网络盒子编码" :label-width="200">
              <span>{{basicInfo.netBoxSn}}</span>
            </FormItem>
            <FormItem class="row" label="房间id" :label-width="200">
              <span>{{basicInfo.roomId || '-'}}</span>
            </FormItem>
            <FormItem class="row" label="门店&&房间名" :label-width="200">
              <span>{{`${basicInfo.chainName||''}-${basicInfo.roomName||''}`}}</span>
            </FormItem>
            <FormItem class="row" label="门锁是否在线" :label-width="200">
              <span>{{basicInfo.lockNetworkState ? '是' : '否'}}</span>
            </FormItem>
            <FormItem class="row" label="盒子是否在线" :label-width="200">
              <span>{{basicInfo.boxNetworkState ? '是' : '否'}}</span>
            </FormItem>
            <FormItem class="row" label="门锁低电量" :label-width="200">
              <span>{{basicInfo.isLowBattery ? '是' : '否'}}</span>
            </FormItem>
            <FormItem class="row" label="门锁的电压" :label-width="200">
              <span>{{basicInfo.electricValue || '-'}}</span>
            </FormItem>
            <FormItem class="row" label="门锁当前时间" :label-width="200">
              <span>{{basicInfo.lockTime | formatTime}}</span>
            </FormItem>
            <FormItem class="row" label="信息更新时间" :label-width="200">
              <span>{{basicInfo.lastUpdateTime | formatTime}}</span>
            </FormItem>
            <FormItem style="margin-top:10px">
              <Button type="success" @click="getLockDynamicsInfo">更新数据</Button>
              <Button type="info" @click="calibrateLockTime">校准门锁时间</Button>
            </FormItem>
          </Form>
        </TabPane>
        <TabPane label="开门记录" :disabled="basicInfo.lockModelId == 11" name="openRecond">
          <Form inline>
            <FormItem label="开门时间" :label-width="75">
              <DatePicker type="datetimerange" class="hidden-clear-btn" v-model="searchTime" :clearable="false" style="width:300px"></DatePicker>
            </FormItem>
            <FormItem label="开门类型" :label-width="75">
              <Select style="width:120px" v-model="recordSearch.openType">
                <Option v-for="(item, index) in openDoorType" :key="index" :value="item.id">{{item.value}}</Option>
              </Select>
            </FormItem>
            <FormItem label="开门状态" :label-width="75">
              <Select style="width:120px" v-model="recordSearch.status">
                <Option :value="-1">全部</Option>
                <Option :value="1">成功</Option>
                <Option :value="0">失败</Option>
              </Select>
            </FormItem>
            <FormItem label="开门人" :label-width="75">
              <Input v-model="recordSearch.handlerName"></Input>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="()=>changePage(1)">查询</Button>
            </FormItem>
          </Form>
          <Table :columns="recodeColumns" :data="openRecond"></Table>
          <Page show-sizer :total="recordSearch.total" :current="recordSearch.page" :page-size="recordSearch.pageSize" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
        </TabPane>
        <TabPane label="通电记录" name="openElecRecond">
          <Form inline>
            <FormItem label="申请时间" :label-width="75">
              <DatePicker type="datetimerange" class="hidden-clear-btn" v-model="recordElecSearch.searchTime" :clearable="false" style="width:300px"></DatePicker>
            </FormItem>
            <FormItem label="申请状态" :label-width="75">
              <Select style="width:120px" v-model="recordElecSearch.status">
                <Option :value="-1">全部</Option>
                <Option :value="0">通电</Option>
                <Option :value="1">断电</Option>
              </Select>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="()=>changeElecPage(1)">查询</Button>
            </FormItem>
          </Form>
          <Table :columns="recodeElecColumns" :data="openElecRecond"></Table>
          <Page show-sizer :total="recordElecSearch.total" :current="recordElecSearch.page" :page-size="recordElecSearch.pageSize" @on-change="changeElecPage" @on-page-size-change="changeElecPageSize"></Page>
        </TabPane>
        <TabPane label="密码信息" :disabled="basicInfo.pwdFunc==1" name="passwordInfo">
          <Form inline>
            <FormItem label="密码类型" :label-width="105">
              <Select style="width:120px" v-model="pwdCondition.pwdType">
                <Option :value="-1">全部</Option>
                <Option :value="4">长租密码</Option>
                <Option :value="1">客人密码</Option>
                <Option :value="2">管家密码</Option>
                <Option :value="5">即时密码</Option>
                <Option :value="3">超级密码</Option>
              </Select>
            </FormItem>
            <FormItem label="密码状态" :label-width="105">
              <Select style="width:120px" v-model="pwdCondition.isValid">
                <Option :value="-1">全部</Option>
                <Option :value="1">有效</Option>
                <Option :value="0">失效</Option>
              </Select>
            </FormItem>
            <FormItem label="密码" :label-width="65">
              <Input v-model="pwdCondition.pwdContent" placeholder="请输入完整密码"></Input>
            </FormItem>
            <br>
            <FormItem>
              <Button type="primary" @click="pwdFilter">查询</Button>
            </FormItem>
            <FormItem>
              <Button type="success" @click="getLockPasswordList">刷新</Button>
            </FormItem>
            <FormItem>
              <Button type="info" @click="addSupperPwdBtn">新增超级密码</Button>
            </FormItem>
            <FormItem>
              <Button type="info" @click="addLongPwdBtn">新增长租密码</Button>
            </FormItem>
            <FormItem>
              <Button type="info" @click="addJustPwdBtn">新增即时密码</Button>
            </FormItem>
            <FormItem>
              <Button type="info" @click="addOfflinePwdBtn">新增离线密码</Button>
            </FormItem>
          </Form>
          <Table :columns="passwordColumns" :data="pwdFilterList"></Table>
        </TabPane>
        <Page></Page>
      </Tabs>
    </section>
    <Modal :title="addPwdModal.title" v-model="addPwdModal.display" @on-ok="addPwdEvent">
      <Form label-position="left">
        <FormItem label="门锁型号" :label-width="100">
          <Input disabled v-model="lockModelName"></Input>
        </FormItem>
        <FormItem label="门锁ID" :label-width="100">
          <Input disabled v-model="lockId"></Input>
        </FormItem>
        <FormItem label="密码生效时间" :label-width="100">
          <DatePicker type="datetimerange" :disabled="addPwdModal.type==3" class="time-takes" style="width:350px" format="yyyy-MM-dd HH:00:00" :options="disableDateOptions" :clearable="false" :editable="false" v-model="dateRange"></DatePicker>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
import Utils from "../../../utils";
import API from "../../../api";
import Moment from 'moment';

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.lockId = Utils.getUrlParameterByName("lockId");
    this.roomId = Utils.getUrlParameterByName("roomId");
    this.roomName = Utils.getUrlParameterByName("roomName");
    this.chainName = Utils.getUrlParameterByName("chainName");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    await this.queryLockModel();
    await this.queryLockList();
    this.getLockDynamicsInfo();
    // this.lockTypeName = this.getModelName(this.basicInfo.lockModelId)
  },
  watch: {
    basicInfo(val) {
      if(val.lockModelId) {
        let modelObj = (this.lockModelList.filter((item) => item.lockModelId==val.lockModelId))[0];
        if(modelObj) {
          this.lockModelName = modelObj.modelName;
        } 
      }
    }
  },
  data () {
    return {
      resetArr: [], // 把点击了重置的 lockId 放到数组中，显示 loading
      searchTime: [Moment().subtract(7,'days').format('YYYY-MM-DD 00:00:00'), Moment().add(1,'days').format('YYYY-MM-DD 00:00:00')],
      disableDateOptions: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      openRecond: [],
      openElecRecond: [],
      pwdList: [],
      pwdFilterList: [],
      basicInfo: {},
      lockModelName: '',
      lockModelList: [],
      dateRange: [Moment().format('YYYY-MM-DD HH:mm:ss'), Moment().add(1,'days').format('YYYY-MM-DD HH:mm:ss')],
      recordSearch: {
        openType: -1,
        status: -1,
        handlerName: '',
        page: 1,
        pageSize: 10,
        total: 0
      },
      recordElecSearch: {
        searchTime: [Moment().subtract(7,'days').format('YYYY-MM-DD 00:00:00'), Moment().add(1,'days').format('YYYY-MM-DD 00:00:00')],
        openType: -1,
        status: -1,
        operator: '',
        page: 1,
        pageSize: 10,
        total: 0
      },
      recodeColumns: [
        {
          title: '开门类型',
          width: 200,
          align: 'center',
          key: 'openType'
          // render: (h, param) => {
          //   let openTypeTxt = ''
          //   this.openDoorType.map(item => {
          //     if (param.row.openType === item.id) {
          //       openTypeTxt = param.row.openType === -1 ? '其他开门方式' : item.value
          //     }
          //   })
          //   return h('span', {}, openTypeTxt)
          // }
        },
        {
          title: '开门密码/标识',
          width: 200,
          align: 'center',
          render: (h, param) => {
            return h('span', {}, param.row.openContent || '-')
          }
        },
        {
          title: '开门人',
          width: 200,
          align: 'center',
          key: 'handlerName'
        },
        {
          title: '开门时间',
          width: 200,
          align: 'center',
          render: (h, param) => {
            return h('span', Moment(param.row.openTime).format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: '开门状态',
          width: 200,
          align: 'center',
          render: (h, param) => {
            return h('Tag', {
              props: {
                color: param.row.isSuccess ? 'green' : 'red'
              }
            }, param.row.isSuccess ? '成功' : '失败')
          }
        },
      ],
      recodeElecColumns: [
        {
          title: '通电类型',
          width: 100,
          align: 'center',
          render: (h, param) => {
            return h('Tag', {}, ['清洁类','维修类','住房类'][param.row.type - 1] ||  '-')
          }
        },
        {
          title: '通电原因',
          width: 100,
          align: 'center',
          render: (h, param) => {
            return h('Tag', {}, param.row.reson ||  '-')
          }
        },
        {
          title: '通电状态',
          width: 100,
          align: 'center',
          render: (h, param) => {
            return h('Tag', {
              props: {
                color: param.row.isDel === 0 && param.row.status === 0 ? 'green' : 'red'
              }
            }, param.row.isDel === 0 && param.row.status === 0 ? '通电' : param.row.isDel === 0 && param.row.status === 1 ? '断电' : '无效')
          }
        },
        {
          title: '计划通电时间',
          width: 320,
          align: 'center',
          render: (h, param) => {
            return h('div', [
              h('span', {}, param.row.setoutStartTime!==null ?  Moment(param.row.setoutStartTime).format('YY-MM-DD HH:mm:ss') : '-'),
              h('span', {}, ' ~ '),
              h('span', {}, param.row.setoutEndTime!==null ?  Moment(param.row.setoutEndTime).format('YY-MM-DD HH:mm:ss') : '-')
            ])
          }
        },
        {
          title: '实际断电时间',
          width: 320,
          align: 'center',
          render: (h, param) => {
            return h('div', [
              h('span', {}, param.row.statrtTime!==null ?  Moment(param.row.statrtTime).format('YY-MM-DD HH:mm:ss') : '-'),
              h('span', {}, ' ~ '),
              h('span', {}, param.row.endTime!==null ?  Moment(param.row.endTime).format('YY-MM-DD HH:mm:ss') : '-')
            ])
          }
        },
        {
          title: '创建时间',
          width: 280,
          align: 'center',
          render: (h, param) => {
            return h('div', [
              h('span', {}, param.row.applyOpenOperator || '-'),
              h('span', {}, ' | '),
              h('span', {}, Moment(param.row.createTime).format('YY-MM-DD HH:mm:ss'))
            ])
          }
        },
        {
          title: '最后更新时间',
          width: 280,
          align: 'center',
          key: 'updateTime',
          render: (h, param) => {
            return h('div', [
              h('span', {}, param.row.applyCloseOperator || param.row.applyOpenOperator || '-'),
              h('span', {}, ' | '),
              h('span', {}, Moment(param.row.updateTime).format('YY-MM-DD HH:mm:ss'))
            ])
          }
        },
      ],
      passwordColumns: [
        {
          title: 'ID',
          width: 100,
          align: 'center',
          key: 'id'
        },
        {
          title: '密码类型',
          width: 100,
          align: 'center',
          render: (h, param) => {
            const typeArr = ['','客人密码','管家密码','超级密码','长租密码','即时密码','离线密码']
            return h('span', {}, typeArr[param.row.pwdType])
          }
        },
        {
          title: '密码',
          width: 100,
          align: 'center',
          key: 'pwdContent'
        },
        {
          title: 'SN',
          width: 250,
          align: 'center',
          key: 'sn'
        },
        {
          title: '状态',
          width: 100,
          align: 'center',
          render: (h, param) => {
            return h('Tag', {
              props: {
                color: param.row.isValid ? 'green' : 'red'
              }
            }, param.row.isValid ? '有效' : '失效')
          }
        },
        {
          title: '创建时间',
          width: 120,
          align: 'center',
          key: 'createTime',
          render: (h, param) => {
            return h('span', {}, Moment(param.row.createTime).format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: '计划生效时间',
          width: 120,
          align: 'center',
          key: 'startTime',
          render: (h, param) => {
            return h('span', {}, param.row.pwdType==5 ? '' : Moment(param.row.startTime).format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: '计划失效时间',
          width: 120,
          align: 'center',
          key: 'endTime',
          render: (h, param) => {
            return h('span', {}, param.row.pwdType==5 ? '' : Moment(param.row.endTime).format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: '最后更新时间',
          width: 150,
          align: 'center',
          key: 'updateTime',
          render: (h, param) => {
            return h('div', [
              h('span', {}, param.row.handlerName || ''),
              h('span', {}, ' | '),
              h('span', {}, Moment(param.row.updateTime).format('YYYY-MM-DD HH:mm:ss'))
            ])
          }
        },
        {
          title: '操作',
          width: 100,
          align: 'center',
          render: (h, param) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  loading: this.resetArr.length && this.resetArr.includes(param.row.id) ? true : false
                },
                on: {
                  click: () => {
                    let obj = param.row;
                    if(!obj.isValid) {
                      this.$Notice.error({
                        title: '该密码无效，不可重置'
                      })
                      return
                    }else if(obj.pwdType===6) {
                      this.$Notice.error({
                        title: '离线密码不支持重置'
                      })
                      return
                    }else{
                      if(obj.pwdType === 5) {
                        this.$Notice.error({
                          title: '即时密码不可重置'
                        })
                        return
                      }
                      this.$Modal.confirm({
                        title: '信息提示',
                        content: '<p>重置后本密码将立即失效</p><p>系统重新生成时效一致的新密码</p><p>确定重置？</p>',
                        onOk: () => {
                          this.resetArr.push(obj.id)
                          this.restLockPwd(obj)
                        }
                      });
                    }
                  }
                }
              }, '重置')
            ])
          }
        }
      ],
      addPwdModal: {
        display: false,
        title: '新增密码',
        type: 1
      },
      pwdCondition: {
        pwdType: -1,
        isValid: -1,
        pwdContent: ''
      },
      openDoorType: [
        {
          id: -1,
          value: '全部'
        },
        {
          id: 1,
          value: '远程开门'
        },
        {
          id: 2,
          value: '蓝牙开门'
        },
        {
          id: 3,
          value: '密码开门'
        },
        {
          id: 4,
          value: '其他类型'
        }
      ]
    }
  },
  methods: {
    changeTab(name) {
      switch (name) {
        case 'basicInfo':
          this.getLockDynamicsInfo();
          break;
        case 'openRecond':
          this.lockopenLotg();
          break;
        case 'openElecRecond':
          this.lockopenElecLotg();
          break;
        case 'passwordInfo':
          this.getLockPasswordList();
          break;
      }
    },
    changePage(page) {
      this.recordSearch.page = page;
      this.lockopenLotg();
    },
    changePageSize(pageSize) {
      this.recordSearch.page = 1;
      this.recordSearch.pageSize = pageSize;
      this.lockopenLotg();
    },
    changeElecPage(page) {
      this.recordElecSearch.page = page;
      this.lockopenElecLotg();
    },
    changeElecPageSize(pageSize) {
      this.recordElecSearch.page = 1;
      this.recordElecSearch.pageSize = pageSize;
      this.lockopenElecLotg();
    },
    pwdFilter() {
      let condition = this.pwdCondition;
      console.info(condition)
      this.pwdFilterList = this.pwdList;
      Object.keys(condition).map(key => {
        if(condition[key]!=-1 && String(condition[key]).trim() != ''){
          this.pwdFilterList = this.pwdList.filter(item => {
            return item[key] == condition[key]
          })
        }
      })
      
    },
    getModelName(modelId) {
      let modelObj = (this.lockModelList.filter((item) => item.lockModelId==modelId))[0];
      return (modelObj ? modelObj.modelName : '')
    },
    addSupperPwdBtn() {
      this.dateRange = [Moment().format('YYYY-MM-DD HH'), Moment().add(1,'days').format('YYYY-MM-DD HH')];
      this.addPwdModal.title = "新增超级密码";
      this.addPwdModal.type = 1;
      this.addPwdModal.display = true;
    },
    addLongPwdBtn() {
      this.dateRange = [Moment().format('YYYY-MM-DD HH'), Moment().add(5,'days').format('YYYY-MM-DD HH')];
      this.addPwdModal.title = "新增长租密码";
      this.addPwdModal.type = 2;
      this.addPwdModal.display = true;
    },
    addJustPwdBtn() {
      this.dateRange = [Moment().format('YYYY-MM-DD HH:mm:ss'), Moment().add(24,'h').format('YYYY-MM-DD HH:mm:ss')];
      this.addPwdModal.title = "新增即时密码";
      this.addPwdModal.type = 3;
      this.addPwdEvent();
    },
    addOfflinePwdBtn() {
      if (!this.basicInfo.supportOfflinePwd) {
        this.$Notice.error({
          title: '该门锁没有离线密码'
        })
        return
      }
      this.addPwdModal.title = "新增离线密码";
      this.addPwdModal.type = 4;
      this.addPwdEvent();
    },
    async addPwdEvent() {
      let param = {
        startTime: Moment(this.dateRange[0]).format('YYYY-MM-DD HH:mm:ss'),
        isMaster: '',
        lockId: this.lockId,
        pwdType: ['','super','lrpwd','realtime'][this.addPwdModal.type],
        roomId: '',
        sn: `01${new Date().getTime()}${(Math.random()*100).toFixed(0)}`,
        endTime: Moment(this.dateRange[1]).format('YYYY-MM-DD HH:mm:ss'),
        writeTime: '',
        remark: JSON.stringify({operUserName:this.username,tip:'OMS创建门锁密码'}),
      }
      switch(this.addPwdModal.type){
        case 1:
          this.addPwdApi('setSupperPwd', param);
          break;
        case 2:
          this.addPwdApi('setLongTimePwd', param);
          break;
        case 3: 
          this.$Modal.confirm({
            title: '消息提醒',
            content: `<p>密码生成后即时生效，一经使用立即失效</p><p>确定新增？</p>`,
            onOk: () => {
              this.addPwdApi('setJustTimePwd', param);
            }
          });
          break;
        case 4: 
          this.$Modal.confirm({
            title: '消息提醒',
            content: `<p>密码有效时间以门锁实际计划有效时间为准</p><p>确定新增？</p>`,
            onOk: () => {
              this.addPwdApi('setofflinePwd', {
                lockId: param.lockId,
                operatorUserName: this.username,
                remark: "OMS增加离线密码"
              })
            }
          });
          break;
      }
    },
    async addPwdApi(api, param) {
      let resp = (await API.omsAPI[this.env].deviceModule[api](param, this.token)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '新增失败',
          desc: resp.msg
        })
        return
      }
      if(resp.stat === 'fail') {
        this.$Notice.error({
          title: '新增失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
        title: '新增成功'
      })
      this.getLockPasswordList()
    },
    async queryLockModel() {
      let resp = (await API.omsAPI[this.env].deviceModule.queryLockModel(this.token)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '获取门锁型号失败',
          desc: '新增密码失败，请重试...'
        })
        return
      }
      this.lockModelList = resp.lockModelList;
    },
    async lockopenLotg() {
      let filter = {
        beginDate: Moment(this.searchTime[0]).format('YYYY-MM-DD HH:mm:ss'),
        endDate: Moment(this.searchTime[1]).format('YYYY-MM-DD HH:mm:ss'),
        handlerName: this.recordSearch.handlerName,
        lockId: this.lockId,
        openType: this.recordSearch.openType == -1 ? '' : this.recordSearch.openType,
        status: this.recordSearch.status == -1 ? '' : this.recordSearch.status
      }
      let resp = (await API.omsAPI[this.env].deviceModule.lockopenLotg(
        JSON.stringify(filter),
        this.recordSearch.page,
        this.recordSearch.pageSize,
        this.token
      )).data
      if(resp.retCode) {
        this.$Notice.error({
          title: '获取开门记录失败',
          desc: resp.msg
        })
        return 
      }
      this.openRecond = resp.content;
      this.recordSearch.total = resp.total;
    },
    async lockopenElecLotg() {
      let filter = {
        page: this.recordElecSearch.page,
        pageSize: this.recordElecSearch.pageSize,
        minTime: Moment(this.recordElecSearch.searchTime[0]).format('YYYY-MM-DD HH:mm:ss'),
        maxTime: Moment(this.recordElecSearch.searchTime[1]).format('YYYY-MM-DD HH:mm:ss'),
        operator: this.recordElecSearch.operator,
        roomId: this.roomId ? this.roomId : this.basicInfo.roomId,
        openType: this.recordElecSearch.openType == -1 ? '' : this.recordElecSearch.openType,
        isDel: this.recordElecSearch.status == -1 ? '' : 0,
        status: this.recordElecSearch.status == -1 ? '' : this.recordElecSearch.status
      }
      let resp = (await API.omsAPI[this.env].clientServer.getApplyElec(filter, {
        'isForm': true,
        'x-ca-stage': Utils.aliHeaderEnv(this.env), 
        'Authorization': Utils.findFromLocalStorage("Author-token"),
      }
      )).data
      if(resp.retCode) {
        this.$Notice.error({
          title: '获取记录失败',
          desc: resp.msg
        })
        return 
      }
      this.openElecRecond = resp.list;
      this.recordElecSearch.total = resp.total;
    },
    async getLockDynamicsInfo() {
      let resp = (await API.omsAPI[this.env].deviceModule.getLockDynamicsInfo(this.lockId, this.token)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '获取信息失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
        title: '获取数据成功'
      })
      this.basicInfo = Object.assign({}, this.basicInfo, resp);
    },
    async getLockPasswordList() {
      let resp = (await API.omsAPI[this.env].deviceModule.getLockPasswordList(this.lockId, this.token)).data
      if(resp.retCode){
        this.$Notice.error({
          title: '获取密码失败',
          desc: resp.msg
        })
        return
      } 
      this.pwdFilterList = this.pwdList = resp;
      this.$Notice.success({
        title: '获取成功'
      })
    },
    async restLockPwd(obj) {
      let resp = (await API.omsAPI[this.env].deviceModule.restLockPwd(
        obj.id,
        obj.pwdType,
        this.username,
        this.token
      )).data;
      this.resetArr.map((item, index) => {
        if(item === obj.id) {
          this.resetArr.splice(index, 1)
        }
      })
      if(resp.retCode) {
        this.$Notice.error({
          title: '重置失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
        title: '重置成功'
      })
      this.getLockPasswordList()
    },
    async calibrateLockTime() {
      let resp = (await API.omsAPI[this.env].deviceModule.calibrateLockTime(this.lockId, this.token)).data
      if(resp.retCode) {
        this.$Notice.error({
          title: '校准时间失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
        title: '校准时间成功'
      })
    },
    async queryLockList() {
      let resp = (await API.omsAPI[this.env].deviceModule.queryAllLock(
        {
          page: 1,
          size: 10,
          filter: JSON.stringify({lockId:this.lockId}),
          orderBy: "lockId",
          sort: "desc",
        },
        this.token
      )).data; 
      if(resp.retCode){
        this.$Notice.error({
          title: '查询失败',
          desc: resp.msg
        })
        return
      }
      this.basicInfo = Object.assign({}, this.basicInfo, resp.content[0]);
    },
  },
  filters: {
    formatTime: function(val) {
      if(!val) return '-';
      return Moment(val).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="scss" scoped>
.row{
  margin-bottom: 0;
}
</style>




// WEBPACK FOOTER //
// src/pages/smart-device/samrt-lock/detail.vue